import React from 'react';
import PropTypes from 'prop-types';

// Material components
import { Box, Typography } from '@material-ui/core';
import { Rating } from '@material-ui/lab';

// Styles
import useStyles from '../../../../assets/styles/components/cards/itemListCourseCard/itemListCourseCardMediaStyle';

// Utils
import objectIsEmpty from '../../../../utils/objectIsEmpty';

const ItemListCourseCardMedia = ({backgroundImage, ratingData, sourceIdLogo}) => {
    const classes = useStyles({backgroundImage});
    
    return (
        <Box className={classes.rootTwoSectionMedia}>
            <Box className={classes.rootTwoSectionContainer}>
                <Box className={classes.ratingContainer}> 
                    {
                        !objectIsEmpty(ratingData) && <>
                            <Box className={classes.ratingNumberContainer}><Typography variant="caption" className={`semi-bold ${classes.ratingNumber}`}>{ratingData.number}</Typography></Box>
                            <Rating name="half-rating" defaultValue={ratingData.number} precision={0.5} readOnly />
                        </>
                    }
                </Box>
            </Box>
        </Box>
    );
};

ItemListCourseCardMedia.defaultProps = {
    backgroundImage: '',
    ratingData: {},
};
  
ItemListCourseCardMedia.propTypes = {
    backgroundImage: PropTypes.string,
    ratingData: PropTypes.shape({
        number: PropTypes.number
    }),
    sourceIdLogo: PropTypes.number.isRequired,
};

export default ItemListCourseCardMedia;